<div class="a-modal-title"
     *ngIf="modalData?.showIcon">
  <i class="icon fi"
     [ngClass]="modalData?.iconClassName"
  ></i>
</div>

<ng-template [ngIf]="!!modalData.message" [ngIfElse]="staticMsg" [ngIfThen]="dynamicMsg"> </ng-template>
<ng-template #dynamicMsg>
  <div class="a-modal-text"
       [innerHTML]="modalData?.message"
       vTp="header">
  </div>
</ng-template>
<ng-template #staticMsg>
  <div class="a-modal-text"
       [innerHTML]="modalData?.headerText | translate"
       vTp="header">
  </div>
</ng-template>
<div class="a-modal-button">
  <div class="a-button-ok"
       (click)="submitFunc($event)"
       [innerHtml]="modalData?.submitBtnText | translate">
  </div>

  <a class="a-button-ok"
       *ngIf="modalData?.hidePopupBtn"
       (click)="hideFunc($event)"
       [innerHtml]="modalData?.hidePopupBtnText | translate">
  </a>
</div>
